import { useEffect, useState, useRef } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import {
  ButtonAdd,
  ButtonEdit,
  ButtonOther,
} from "../../../Components/Button/Button";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import { AlertError } from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import AddEmailData from "./AddEmailData";
import * as SiIcons from "react-icons/si";
import { CSVLink } from "react-csv";
import Chip from "@mui/material/Chip";

function EmailData() {
  const [openDialogformEdit, setOpenDialogFormEdit] = useState(false);
  const [openDialogformAdd, setOpenDialogFormAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [countRowData, setCountRowData] = useState(0);
  const [page, setPage] = useState(0);
  const user = useRecoilValue(userData);
  const [email, setEmailData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [emailSendFileId, setEmailSendFileId] = useState("");

  const getData = async () => {
    setLoading(true);
    await axios
      .get(UrlApi + "get_email_data", authorization)
      .then((res) => {
        res.data.map((item, index) => {
          item.list_no = index + 1;
        });
        setEmailData(res.data);
        exportExcells(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };

  useEffect(() => {
    document.addEventListener('keydown', detextKeyDown, true);
    getData();
  }, [openDialogformEdit === false, openDialogformAdd === false]);

  const detextKeyDown = (e) =>{
    if(e.key === 'F9'){
      setOpenDialogFormAdd(true);
      return false;
    }
  }

  const columns = [
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "2rem",
        maxWidth: "2rem",
      },
      cellStyle: { width: "2rem", maxWidth: "2rem" },
    },
    {
      title: "เปิด",
      field: "master_email_send_file_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: "2rem",
        maxWidth: "2rem",
      },
      cellStyle: { width: "2rem", maxWidth: "2rem" },
      render: (rowData) => (
        <ButtonEdit
          onClick={() => {
            setEmailSendFileId(rowData.master_email_send_file_id);
            setOpenDialogFormEdit(true);
          }}
        />
      ),
    },
    {
      title: "Email",
      field: "master_email_send_file",
      headerStyle: {
        width: "5%",
        maxWidth: "5%",
        height: "10px",
      },
      cellStyle: { width: "5%", maxWidth: "5%" },
    },
    {
      title: "สถานะการใช้งาน",
      field: "master_email_send_file_active",
      render: (rowData) => {
        let color = "";
        let fontColor = "#FFFFFF";
        let label = "";
        switch (rowData.master_email_send_file_active) {
          case true:
            color = "#92CEA8";
            label = "เปิดการใช้งาน";
            break;
          default:
            color = "#F898A4";
            label = "ปิดการใช้งาน";
        }
        return (
          <Chip
            label={label}
            style={{
              background: color,
              color: fontColor,
              fontFamily: "Sarabun",
            }}
          />
        );
      },
      headerStyle: {
        width: "80%",
        maxWidth: "80%",
      },
      cellStyle: { width: "80%", maxWidth: "80%"},
    },
  ];

  const HeaderPage = () => {
    return (
      <>
        <div style={{paddingTop: '10px'}}>
         <label style={{marginLeft: "10px", fontSize: '18px'}}>
            ข้อมูล Email
         </label>
        <div style={{ display: "flex", justifyContent: "space-between", width: '100%'}}>
          <ButtonAdd
            label="เพิ่ม"
            variant="contained"
            onClick={() => {
              setOpenDialogFormAdd(true);
            }}
          />
          <CSVLink
            style={{
              textDecoration: "none",
              justifyContent: 'flex-end'
            }}
            data={dataExport}
            filename={"Email ที่ใช้ส่งข้อมูล.csv"}
            target="_blank"
          >
            {
              <ButtonOther
                onClick={()=>{
                  
                }}
                message="ส่งออก"
                width="15ch"
                startIcon={<SiIcons.SiMicrosoftexcel />}
              />
            }
          </CSVLink>
        </div>
      </div>
      </>
    );
  };

  const exportExcells = (dataExport) => {
    let columnExport = [];
    columns.map((item)=>{
      if(item.title !== 'เปิด'){
        columnExport.push(item.title);
      }
    });
    const csvData = [
      ["", "", "", ""],
      ["", "Email ที่ใช้ส่งข้อมูล"],
      columnExport,
    ];
    let data = [];
    dataExport.map((item) => {
      data = [
        item.list_no,
        item.master_email_send_file,
        item.master_email_send_file_active ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน',
      ];
      csvData.push(data);
    });
    setDataExport(csvData);
  };

  return (
    <>
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        <DataTable
          exportButton={false}
          columns={columns}
          data={email}
          width="100%"
          countRowData={email.length}
          pageSize={pageSize}
        />
      </Card>
      {openDialogformEdit && (
        <AddEmailData
          onCancel={() => setOpenDialogFormEdit(false)}
          open={openDialogformEdit}
          emailSendFileId={emailSendFileId}
        />
      )}
      {openDialogformAdd && (
        <AddEmailData
          onCancel={() => setOpenDialogFormAdd(false)}
          open={openDialogformAdd}
          emailSendFileId={null}
        />
      )}
      <Loading open={loading} />
    </>
  );
}

export default EmailData;
